function calculateImageSize(oldWidth, oldHeight, winWidth, winHeight) {
  let width;
  let height;
  if (oldWidth / winWidth > oldHeight / winHeight) {
    width = winWidth;
    height = oldHeight * (width / oldWidth);
  } else {
    height = winHeight;
    width = oldWidth * (height / oldHeight);
  }
  return { width, height };
}

/* http://photoswipe.com/documentation/options.html
   node_modules/photoswipe/dist/photoswipe-ui-default.js
   Review _defaultUIOptions for available options */
export const getDefaultOptions = imageIndex => {
  return {
    bgOpacity: 0.3,
    captionEl: true,
    closeEl: true,
    escKey: true,
    fullscreenEl: false,
    zoomEl: false,
    getDoubleTapZoom: () => 2,
    history: false,
    index: imageIndex,
    maxSpreadZoom: 2,
    shareEl: false,
    counterEl: false,
    arrowEl: true,
    preloaderEl: false,
    spacing: 0.05
  };
};

export const transformImagesToPhotoswipe = (images, isDesktop = false) => {
  return images.map(image => {
    const imgObj = { src: image.zoom };

    const winHeight = window.innerHeight;
    const winWidth = window.innerWidth;

    const img = new Image();
    img.addEventListener('load', function() {
      if (isDesktop) {
        const { width, height } = calculateImageSize(this.width, this.height, winWidth, winHeight);
        imgObj.w = width;
        imgObj.h = height;
      } else {
        imgObj.w = this.width / 3;
        imgObj.h = this.height / 3;
      }
    });
    img.src = image.zoom;

    return imgObj;
  });
};

export const updatePhotoswipeImages = oldImages => {
  const winHeight = window.innerHeight;
  const winWidth = window.innerWidth;
  return oldImages.map(image => {
    const { width, height } = calculateImageSize(image.w, image.h, winWidth, winHeight);
    const newImage = { src: image.src };
    newImage.w = width;
    newImage.h = height;
    newImage.msrc = image.src;
    return newImage;
  });
};
